import Vue from "vue";
import App from "./App.vue";
import axios from "axios";
import jQuery from "jquery";
import { BootstrapVue } from "bootstrap-vue";

Vue.use(BootstrapVue, axios);
window.$ = window.jQuery = jQuery;
Vue.prototype.axios = axios;
Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
}).$mount("#app");
